import { createFileRoute } from "@tanstack/react-router";
import { InfoModal } from "@/components/InfoModal/InfoModal";
import { SkipLink } from "@/components/SkipLink/SkipLink";
import { Stage } from "@/components/Stage/Stage";
import { StoryInspector } from "@/components/StoryInspector/StoryInspector";
import { ViewSwitch } from "@/views/ViewSwitch";
import { useGameSession } from "@/hooks/useGameSession";
import { useVideoSkip } from "@/hooks/useVideoSkip";
import { useViewStore } from "@/stores/view";

export const Route = createFileRoute("/")({ component: Game });

function LoadFailure({ message }: { message: string }) {
  return (
    <div className="flex h-full items-center justify-center p-8 text-center text-ink-muted">
      <p>{message}</p>
    </div>
  );
}

function Game() {
  const view = useViewStore((state) => state.view);
  const session = useGameSession();

  useVideoSkip();

  return (
    <>
      <SkipLink />
      <Stage>
        {session.failure === null ? (
          <ViewSwitch view={view} />
        ) : (
          <LoadFailure message={session.failure} />
        )}
      </Stage>
      <InfoModal />
      {STORY_TOOLS_ENABLED && <StoryInspector />}
    </>
  );
}
